import { BaseWebComponentController } from '../../../../../framework/BaseWebComponentController';
import { templatePlansAndPurchaseTab } from '../view/template';
import { PlansAndPurchaseTabWebComponent } from '../component/PlansAndPurchaseTabWebComponent';
import { PlansAndPurchaseTabView } from '../view/PlansAndPurchaseTabView';
import { PlansAndPurchaseTabRepository } from '../repository/PlansAndPurchaseTabRepository';
import { PlansAndPurchaseTabViewData } from '../types/types';

export class PlansAndPurchaseTabController extends BaseWebComponentController {
  public component: PlansAndPurchaseTabWebComponent;
  public view: PlansAndPurchaseTabView;
  public viewConstructor: typeof PlansAndPurchaseTabView;
  public dataRepository: PlansAndPurchaseTabRepository;
  public dataRepositoryConstructor: typeof PlansAndPurchaseTabRepository;

  constructor(component: PlansAndPurchaseTabWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: PlansAndPurchaseTabView,
      viewTemplate: templatePlansAndPurchaseTab,
      dataRepositoryConstructor: PlansAndPurchaseTabRepository,
    });
  }

  public async getDataForView(): Promise<PlansAndPurchaseTabViewData> {
    this.view.setLoadingState();

    const repository = this.dataRepository;

    const plansAndPurchaseData = await repository.getPlansAndPurchaseData();

    return {
      getPlansAndPurchaseDataResponse: plansAndPurchaseData,
      purchasePageDataProvider: {
        getExtendSeatsPrice: repository.getExtendSeatsPrice.bind(repository),
        getExtendSeatsUrl: repository.getExtendSeatsUrl.bind(repository),
        getRenewalUrl: repository.getRenewalUrl.bind(repository),
      },
    };
  }
}
